import styled from "styled-components";

export const StyledPageWrapp = styled.div`
  position: relative;
  width: 100%;
  margin: 50px auto;
  background: none;
  text-align: center;
  margin: 50px auto;
  padding-top: 20px;

  p {
    display: block;
    font:
      15px/1.5 Arial,
      Sans-Serif;
    color: #4d79ff;
    margin: 0 0 30px 0;
    margin: 50px auto;
    text-align: center;
  }
  h1 {
    font:
      30px/1 Arial,
      Sans-Serif;
    margin: 0 0 30px 0;
    margin: 50px auto;
    text-align: center;
    margin-top: 115px;
    color: #ffffff;
  }
  a {
    font:
      15px/1.5 Arial,
      Sans-Serif;
    color: #ffffff;
    margin: 0 0 30px 0;
    margin: 50px auto;
    padding: 20px 38px;
    text-align: center;
  }
  a:hover {
    color: #fff;
  }
`;

export const SupportLogoWrapper = styled.div`
  position: absolute;
  left: 50%;
  top: 50px;
  transform: translateX(-50%);
  pointer-events: none;
`;
